import _ from 'underscore';
import {
  formatDecimal,
} from '@bingads-webui-campaign/recommendation-core';
import { METRICS } from './consts';

const NUMBER_TYPES = {
  Percentage: 'Percentage',
  Integer: 'Integer',
  Short: 'Short',
};

const METRICS_TYPES = {
  [METRICS.ImpressionShare]: NUMBER_TYPES.Percentage,
  [METRICS.OverlapRate]: NUMBER_TYPES.Percentage,
  [METRICS.AveragePosition]: NUMBER_TYPES.Integer,
  [METRICS.AboveRate]: NUMBER_TYPES.Percentage,
  [METRICS.TopOfPageRate]: NUMBER_TYPES.Percentage,
  [METRICS.AbsoluteTopOfPageRate]: NUMBER_TYPES.Percentage,
  [METRICS.OutrankingShare]: NUMBER_TYPES.Percentage,
  [METRICS.ConversionRate]: NUMBER_TYPES.Percentage,
  [METRICS.SearchTerms]: NUMBER_TYPES.Short,
};

const AuctionInsightMetrics = [
  METRICS.ImpressionShare,
  METRICS.OverlapRate,
  METRICS.AveragePosition,
  METRICS.AboveRate,
  METRICS.TopOfPageRate,
  METRICS.AbsoluteTopOfPageRate,
  METRICS.OutrankingShare,
];

const AuctionInsightMetricsForShopping = [
  METRICS.ImpressionShare,
  METRICS.OverlapRate,
  METRICS.AbsoluteTopOfPageRate,
  METRICS.OutrankingShare,
];

export function isMetricPercentage(metric) {
  return METRICS_TYPES[metric] === NUMBER_TYPES.Percentage;
}

export function formatMetric(i18n, metric, value, label = false) {
  const format = METRICS_TYPES[metric];
  const options = label ?
    { digits: 0 } :
    {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      digits: 2,
    };

  switch (format) {
    case NUMBER_TYPES.Percentage:
      return i18n.formatPercent(value, options);
    case NUMBER_TYPES.Short:
      return formatDecimal(value, i18n);
    case NUMBER_TYPES.Integer:
    default:
      return i18n.formatDecimalToFixed(value, options);
  }
}

export function localizeMetric(i18n, metric) {
  return i18n.getString(`AuctionInsights_ColumnName_${metric}`);
}

export function getLocalizedMetrics(
  i18n, isShoppingCampaignType = false,
  isAvgPositionDeprecationPhase1Enabled = false,
  IsAvgPositionDeprecationPhase2Enabled = false
) {
  let metrics = isShoppingCampaignType ?
    AuctionInsightMetricsForShopping : AuctionInsightMetrics;

  if (!isAvgPositionDeprecationPhase1Enabled) {
    metrics = _.without(metrics, METRICS.AbsoluteTopOfPageRate);
  }

  if (IsAvgPositionDeprecationPhase2Enabled) {
    metrics = _.without(metrics, METRICS.AveragePosition);
  }

  return _.map(metrics, (metric, id) => ({
    id,
    value: localizeMetric(i18n, metric),
    metric,
  }));
}

export function localizeTitle(i18n, metric) {
  return i18n.getString(`Chart_Title_${metric}`);
}
